import { render } from "./UiShare.vue?vue&type=template&id=02a4bd9b&ts=true&lang=pug"
import script from "./UiShare.vue?vue&type=script&setup=true&lang=ts"
export * from "./UiShare.vue?vue&type=script&setup=true&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__